import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4.96077 3.54632L9.61383 8.19938C11.0678 7.28457 12.9326 7.28457 14.3866 8.19938L19.0394 3.5465C14.9717 0.151228 9.02856 0.151168 4.96077 3.54632Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.4536 4.96072L15.8008 9.61359C16.7156 11.0676 16.7156 12.9323 15.8008 14.3863L20.4537 19.0392C23.8488 14.9715 23.8488 9.02844 20.4536 4.96072Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.0395 20.4535L14.3866 15.8005C12.9326 16.7153 11.0678 16.7153 9.61383 15.8005L4.96072 20.4536C9.02853 23.8488 14.9718 23.8488 19.0395 20.4535Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.5465 19.0394L8.19962 14.3863C7.28482 12.9323 7.28482 11.0676 8.19962 9.61359L3.54654 4.96051C0.151168 9.0283 0.151155 14.9716 3.5465 19.0394Z"}}]};

const SupportFilled = Vue.extend<IconProps>({
  name: 'SupportFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'support-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default SupportFilled;
